import React from 'react';
import { styled } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentTypesHeaderContainer = styled.div<{
	isFloating?: boolean;
	hasPointerEvents?: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	position: (props) => {
		return props.isFloating ? 'absolute' : 'relative';
	},
	background: 'transparent',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	pointerEvents: (props) => {
		return props.hasPointerEvents ? 'auto' : 'none';
	},
	width: '100%',
	display: 'grid',
});

const titleAndBreadcrumbsBaseStyles = xcss({
	pointerEvents: 'auto',
	backgroundColor: 'elevation.surface',
	borderRadius: 'radius.small',
	paddingInline: 'space.100',
	paddingBlockEnd: 'space.050',
	display: 'flex',
	flexWrap: 'nowrap',
	paddingBlockStart: 'space.050',
	height: '100%',
});

// Utilized only when the content header is pinned and during the viewing of public whiteboards
const alignCenterStyle = xcss({
	alignSelf: 'center',
});

export const TitleAndBreadcrumbsWrapper = ({
	isContentHeaderPinned = false,
	children,
}: {
	isContentHeaderPinned?: boolean;
	children: React.ReactNode;
}) => {
	return (
		<Box xcss={[titleAndBreadcrumbsBaseStyles, isContentHeaderPinned && alignCenterStyle]}>
			{children}
		</Box>
	);
};
